import { useDispatch } from 'react-redux';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Button } from '@rsos/base-components';
import { DISCREPANCY_REPORTING } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import { setSelectedTool } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { setSelectedTab } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import {
  ALI_DISCREPANCY_TOOL,
  TOOLS_TAB,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import { isDevelopmentEnv } from '@rsos/utils';
import { AliDiscrepancyToolProperties } from './AliDiscrepancyForm/AliDiscrepancyForm';

interface ReportAliDiscrepancyButtonProps {
  originalAddress?: string;
  classOfService?: string;
  phoneNumber?: string;
}

export function ReportAliDiscrepancyButton({
  originalAddress,
  classOfService,
  phoneNumber,
}: ReportAliDiscrepancyButtonProps) {
  const dispatch = useDispatch();
  const { hasCapability } = useHasCapability(DISCREPANCY_REPORTING);

  if (!hasCapability) {
    if (isDevelopmentEnv()) {
      // eslint-disable-next-line no-console
      console.debug('Discrepancy reporting capability not available');
    }
    return null;
  }

  const handleReportDiscrepancy = () => {
    // Prepare tool properties with available address data
    const toolProperties: AliDiscrepancyToolProperties = {
      originalAddress,
      classOfService,
      phoneNumber,
    };

    // Switch to Tools tab with ALI Discrepancy form displayed
    dispatch(
      setSelectedTool({
        tool: ALI_DISCREPANCY_TOOL,
        toolProperties,
      }),
    );
    dispatch(setSelectedTab(TOOLS_TAB));
  };

  return (
    <Button
      data-name="report-ali-discrepancy-button"
      onClick={handleReportDiscrepancy}
      btnType="tertiary"
      size="xxsmall"
    >
      <AttentionTriangleIcon width={12} height={12} />
    </Button>
  );
}
